module.exports = __webpack_public_path__ + "img/img17.e992f355.png";